var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-todo-personal-list.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { currentUser } from "@adornis/users/client/currentUser.js";
import { virtualize } from "@adornis/chemistry/directives/when-seen.js";
import { SubscriptionPagination } from "@adornis/pagination/paginatable.js";
import { AdornisTodo } from "../db/AdornisTodo.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { takeUntil } from "rxjs";
import "./x-todo-card.js";
var XTodoPersonalList = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._currentUser = new RXController(this, currentUser());
    this._todosPaginated = new SubscriptionPagination(
      AdornisTodo.subscribeTodosForUserPaginated.bind(AdornisTodo),
      [""],
      AdornisTodo.allFields,
      5,
      5
    );
    this._todos = new RXController(this, this._todosPaginated.data);
    this._todosLoading = new RXController(this, this._todosPaginated.loadingInitially);
    this._assigneeType = new RXController(this, "me");
    this._assignee = new RXController(this, null);
  }
  connectedCallback() {
    super.connectedCallback();
    this._currentUser.observable.pipe(takeUntil(this.disconnected)).subscribe((user) => this._todosPaginated.updateParameters(user?._id ?? ""));
  }
  render() {
    return xComponents(
      html`
        <x-flex ${css({ maxHeight: "80vh", overflowY: "auto", paddingRight: this.spacing.xs })} space="md">
          <x-flex padding="sm" ${css({ position: "sticky", top: 0, background: "white", zIndex: 1 })}>
            ${this._header()}
          </x-flex>
          ${this._todosList()}
          <x-flex padding="sm" ${css({ position: "sticky", bottom: 0, background: "white" })}>
            ${this._inputField()}
          </x-flex>
        </x-flex>
      `
    );
  }
  _header() {
    return xComponents(
      html`
        <x-flex horizontal crossaxis-center space-between>
          <x-h3>Todos</x-h3>
        </x-flex>
      `
    );
  }
  _inputField() {
    return xComponents(html`
      <x-input
        placeholder="Todo"
        @submit=${async (e) => {
      const inputField = e.currentTarget;
      if (e.detail.value.length > 0) {
        if (!this._assignee.value && this._assigneeType.value === "me") {
          this._assignee.next(this._currentUser.value);
        }
        const newTodo = new AdornisTodo({
          assigneeID: this._assignee.value?._id
        });
        newTodo.name = inputField.value.value;
        await newTodo.create();
        inputField.value.next("");
      }
    }}
      ></x-input>
    `);
  }
  _todosList() {
    if (this._todosLoading.value)
      return xComponents(html` <x-flex center> <x-loader></x-loader> </x-flex> `);
    if (!this._todos.value.length)
      return xComponents(html` <x-flex center> <x-text> Alles erledigt! </x-text> </x-flex>`);
    return xComponents(
      html`<x-flex space="xxs">
        ${repeat(
        this._todos.value,
        (todo) => todo._id,
        (todo, index) => {
          return html`
              ${html` ${virtualize(
            xComponents(html` <x-todo-card .todo=${todo}></x-todo-card> `),
            (oldHeight) => html` <div ${css({ height: oldHeight + "px" })}></div> `,
            {
              dontUnload: true,
              onRender: () => {
                if (index === this._todos.value.length - 2 && this._todosPaginated.totalRequested.getValue() < index + 4)
                  this._todosPaginated.next();
              }
            }
          )}`}
            `;
        }
      )}
      </x-flex> `
    );
  }
};
__decorateClass([
  state()
], XTodoPersonalList.prototype, "_currentUser", 2);
__decorateClass([
  state()
], XTodoPersonalList.prototype, "_todos", 2);
__decorateClass([
  state()
], XTodoPersonalList.prototype, "_todosLoading", 2);
__decorateClass([
  state()
], XTodoPersonalList.prototype, "_assigneeType", 2);
__decorateClass([
  state()
], XTodoPersonalList.prototype, "_assignee", 2);
XTodoPersonalList = __decorateClass([
  customElement("x-todo-personal-list")
], XTodoPersonalList);
export {
  XTodoPersonalList
};
